import { render, staticRenderFns } from "./Facturations.vue?vue&type=template&id=8347dfd4&"
import script from "./Facturations.vue?vue&type=script&lang=ts&"
export * from "./Facturations.vue?vue&type=script&lang=ts&"
import style0 from "./Facturations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports